import React, { useState, useRef, useEffect } from "react";
import { BiNotification, BiSearch } from "react-icons/bi";
import { VscTriangleUp } from "react-icons/vsc";
import { MdWorkspacesOutline } from "react-icons/md";
import Logo from "../components/Logo";
import Sidebar from "../components/Sidebar";
import useOnClickOutside from "../components/UseOnClickOutside";
import { Link } from "react-router-dom";
import { notifs } from "../utils/DataSource";
import { getProfileInfoById } from "../store/actions/AccountActions";
import { useDispatch, useSelector } from "react-redux";
function DashLayout(props) {
  const dispatch = useDispatch();

  const notfRef = useRef();
  useOnClickOutside(notfRef, () => openNotifications(false));
  const myProfile = useSelector((state) => state.stateOfProfiles.userAccount);

  const [notifications, openNotifications] = useState(0);
  function notificationsController() {
    openNotifications(!notifications);
  }

  const style = {
    field: {
      parentDiv:
        "border border-white bg-gray-100 py-2 px-3 rounded flex flex-row focus-within:bg-gray-100",
      input:
        "h-full w-4/5 focus:outline-none text-xs text-gray-500 bg-transparent",
      icon: "m-auto ml-0 mr-1 text-gray-300",
    },
  };
  // getting user id from session
  const userId = JSON.parse(
    `${useSelector((state) => state.auth.session)}`
  ).userId;
  // reload user account info
  useEffect(() => {
    dispatch(getProfileInfoById(userId));
  }, [dispatch, userId]);
  return (
    <div className="bg-gray-100  h-screen overflow-y-hidden flex flex-col w-screen">
      <div className="h-14 bg-white text-gray-500 w-full border-b border-gray-200  px-10 flex flex-row fixed z-10">
        <Link to="/home" className="my-auto ">
          <Logo />
        </Link>

        <div className="xl:block lg:block md:block sm:block hidden w-auto m-auto ml-44">
          <div className={style.field.parentDiv}>
            <BiSearch className={style.field.icon} />
            <input
              type="text"
              placeholder="search..."
              className={style.field.input}
            />
          </div>
        </div>

        <div className="hidden flex-row m-auto mr-2">
          <button
            onClick={() => {
              notificationsController();
            }}
            className={
              notifications
                ? "bg-transparent p-2 rounded-full focus-within:bg-gray-100"
                : "bg-transparent p-2 hover:bg-gray-100 rounded-full title-tip inline-block"
            }
            message="Notifications"
          >
            <BiNotification className="text-md" />
            <span className="absolute -mt-4  w-1.5 h-1.5 rounded-full bg-red-500"></span>
          </button>
          <div
            className={
              notifications
                ? "absolute z-20 notification-card right-36 mt-14 flex flex-col rounded bg-gray-50 border border-white"
                : "hidden"
            }
            ref={notfRef}
          >
            <VscTriangleUp className="absolute -top-3 z-30 right-4 text-white" />
            <div className="flex flex-row p-3">
              {/* <IoMdNotificationsOutline className="text-xl m-auto mr-2 ml-2 text-gray-500" /> */}
              <h2 className="text-xs mx-5 font-semibold m-auto text-gray-500">
                Notifications
              </h2>
            </div>
            <div className="border-b w-full border-gray-100" />
            <div className="p-0 pb-3">
              {notifs.map((notif, i) => {
                return (
                  <div
                    className="flex  text-gray-500 text-xs py-3 p-3 pl-7 cursor-pointer border-b hover:bg-gray-100 border-gray-100"
                    key={i}
                  >
                    <div
                      className={
                        notif.actionCode === "DELETE"
                          ? "m-auto mr-3 w-2 h-2 border border-red-500 rounded-full "
                          : "m-auto mr-3 w-2 h-2 border border-indigo-500 rounded-full bg-"
                      }
                    />
                    <div>
                      <h2 className="font-medium">{notif.source}</h2>
                      <p className="text-gray-600">{notif.message}</p>
                      <p>
                        {notif.time} -- done by {notif.doneBy}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="w-full flex pb-2">
              <Link
                to="/services/notifications"
                className="text-center text-xs m-auto text-indigo-500 hover:text-indigo-500"
              >
                see more
              </Link>
            </div>
          </div>
        </div>
        <Link
          className="my-auto mx-2 text-gray-500 rounded-full bg-indigo-50 hover:bg-indigo-100 p-2 border border-white title-tip inline-block"
          to="/workspaces"
          message="Workspaces"
        >
          <MdWorkspacesOutline />
        </Link>
        {/* user profile */}
        <div className="px-2 py-2 flex flex-row text-xs font-medium text-white m-auto mx-2 mr-0">
          <Link to="/settings">
            <img
              src={
                myProfile.profilePicturePath
                  ? myProfile.profilePicturePath
                  : "https://i1.pngguru.com/preview/137/834/449/cartoon-cartoon-character-avatar-drawing-film-ecommerce-facial-expression-png-clipart.jpg"
              }
              className="w-10 h-10 rounded-full pl-0 border-2 border-indigo-200"
              alt="user"
            />
          </Link>
        </div>
      </div>

      <div className="overflow-y-hidden w-full overflow-x-hidden pt-14 p-0 flex flex-row">
        <div>
          <Sidebar />
        </div>

        {/* <div className="bg-gray-100 h-auto pl-64 pt-12 text-gray-500 flex flex-col w-full text-xs"> */}
        <div className="bg-gray-100 overflow-y-scroll h-full   pt-12 text-gray-500 flex flex-col w-full text-xs mb-5">
          {props.children}
        </div>
      </div>
    </div>
  );
}

export default DashLayout;
